const getLanguages = () => {
  
  const options = {
    method: 'get',
    url: '/languages/all',
    transformResponse: [(result) => {
      result = JSON.parse(result);
      
      let data = result.data.filter(lang => !_.isEmpty(lang.code));
      
      return Object.assign({}, result, {data});
    }]
  }
  
  return axios(options).then(result => {
    let {data} = result.data;
    
    return data.map(obj => {
      let {id, code, description: name} = obj;
      
      return {name, code, id};
    });
  });
};

const getAccounts = () => {
  // todo implement
};

const getUsers = (langs) => {
  return axios.get('/review/user-cache').then(result => {
    let {data} = result;
    
    return data.map(user => {
      
      let {
        id,
        email,
        name,
        notes,
        languages,
        first_name,
        last_name,
        is_reviewer,
      } = user;
      
      let target_language = null;
       
       //@TODO - can a users object have more than 1 language??
       //get the target language object associatted with users languages
       if (langs) {
         target_language = langs.find(lang => {
           let userLang = languages ? languages.toLowerCase() : languages;
          
           return lang.name.toLowerCase() == userLang;
         }) || {};
       }
       
       return {
         id,
         email,
         notes,
         name,
         first_name,
         last_name,
         target_languages: [target_language],
         is_reviewer
       };
     })
  });
}

const mapTargetLanguages = (langsStr, languages) => {
  langsStr = langsStr || '';
  
  return langsStr.split(',').filter(item => item).map(tl => {
    let language = languages.find(l => l.name == tl);

    if (!language) return null;
    
    //@TODO - normalize description param
    return language;
  }).filter(item => item);
}


export { getLanguages, mapTargetLanguages, getUsers };
